var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('ul',{staticClass:"nav"},[_vm._l((_vm.$parent.nav),function(item,i){return [_c('li',{key:i,staticClass:"nav__item"},[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(_vm.$t(item.title)))])],1)]})],2),_c('div',{staticClass:"dropdown-list"},[_c('CurrencyDropdown'),_c('Dropdown')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }